import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import EventMemoryBook from './EventMemoryBook';
import HomePage from './HomePage';
import { getEventByYear, parseEditionYear, getEffectiveLiveMode } from '../utils/eventRouting';
import './YearExperienceHub.css';

function YearExperienceHub({ mode, adminOnly = false }) {
  const { year } = useParams();
  const parsedYear = parseEditionYear(year);
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    async function load() {
      if (!parsedYear) {
        setLoading(false);
        setError('Invalid year.');
        return;
      }
      setLoading(true);
      setError('');
      try {
        const found = await getEventByYear(parsedYear);
        if (!cancelled) {
          setEvent(found);
          if (!found) setError(`No Fresh Meet edition found for ${parsedYear}.`);
        }
      } catch (err) {
        if (!cancelled) setError(err?.message || 'Failed to load event.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [parsedYear]);

  if (!parsedYear) return <Navigate to="/" replace />;
  if (loading) return <div className="year-experience-shell"><p>Loading {parsedYear} edition...</p></div>;
  if (error) return <div className="year-experience-shell"><p>{error}</p></div>;
  if (!event) return <div className="year-experience-shell"><p>No event found.</p></div>;

  const livePublic = getEffectiveLiveMode(event) === 'public';
  if (mode === 'index') {
    const target = livePublic ? 'live' : 'archive';
    return <Navigate to={`/${parsedYear}/${target}`} replace />;
  }

  if (mode === 'live') {
    if (!adminOnly && !livePublic) {
      return <Navigate to={`/${parsedYear}/archive`} replace />;
    }
    return (
      <div className="year-experience-shell">
        <HomePage forcedEventId={event.id} year={parsedYear} />
      </div>
    );
  }

  if (mode === 'archive') {
    return (
      <div className="year-experience-shell">
        <Routes>
          <Route index element={<EventMemoryBook isPublic forcedEventId={event.id} publicPage="main" />} />
          <Route path="leaderboard" element={<EventMemoryBook isPublic forcedEventId={event.id} publicPage="leaderboard" />} />
          <Route path="quotes" element={<EventMemoryBook isPublic forcedEventId={event.id} publicPage="quotes" />} />
          <Route path="gallery" element={<EventMemoryBook isPublic forcedEventId={event.id} publicPage="gallery" />} />
          <Route path="videos" element={<EventMemoryBook isPublic forcedEventId={event.id} publicPage="videos" />} />
          <Route path="*" element={<Navigate to={`/${parsedYear}/archive`} replace />} />
        </Routes>
      </div>
    );
  }

  return <Navigate to={`/${parsedYear}/archive`} replace />;
}

export default YearExperienceHub;
